<template>
  <div class="chart-container" style='position: relative !important; width: 100% !important;'>
    <canvas :id="idcanvas" style="width: 100% !important; height: 100%"></canvas>
  </div>
</template>
<script>
import Chart from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

// Chart.js v2 has no native bar borderRadius. We override the Rectangle draw
// to round the "leading" corners of a bar — the top for vertical bars, the
// right tip for horizontal bars — opt-in per dataset via a `cornerRadius`
// property so charts without it keep their default (square) rendering.
if (!Chart.elements.Rectangle.prototype.__roundedTopPatched) {
  const originalDraw = Chart.elements.Rectangle.prototype.draw;
  Chart.elements.Rectangle.prototype.draw = function() {
    const vm = this._view;
    const dataset = this._chart.data.datasets[this._datasetIndex] || {};
    const radius = dataset.cornerRadius || 0;

    if (!radius) {
      return originalDraw.apply(this, arguments);
    }

    const ctx = this._chart.ctx;

    if (!vm.horizontal) {
      // Vertical bar: round top-left & top-right (positive/upward bars only).
      if (vm.y >= vm.base) {
        return originalDraw.apply(this, arguments);
      }
      const left = vm.x - vm.width / 2;
      const right = vm.x + vm.width / 2;
      const top = vm.y;
      const bottom = vm.base;
      const r = Math.min(radius, vm.width / 2, Math.abs(bottom - top));

      ctx.beginPath();
      ctx.fillStyle = vm.backgroundColor;
      ctx.strokeStyle = vm.borderColor;
      ctx.lineWidth = vm.borderWidth;
      ctx.moveTo(left + r, top);
      ctx.lineTo(right - r, top);
      ctx.quadraticCurveTo(right, top, right, top + r);
      ctx.lineTo(right, bottom);
      ctx.lineTo(left, bottom);
      ctx.lineTo(left, top + r);
      ctx.quadraticCurveTo(left, top, left + r, top);
      ctx.closePath();
    } else {
      // Horizontal bar: round top-right & bottom-right (the tip), for bars
      // extending to the right only.
      if (vm.x <= vm.base) {
        return originalDraw.apply(this, arguments);
      }
      const left = vm.base;
      const right = vm.x;
      const top = vm.y - vm.height / 2;
      const bottom = vm.y + vm.height / 2;
      const r = Math.min(radius, vm.height / 2, Math.abs(right - left));

      ctx.beginPath();
      ctx.fillStyle = vm.backgroundColor;
      ctx.strokeStyle = vm.borderColor;
      ctx.lineWidth = vm.borderWidth;
      ctx.moveTo(left, top);
      ctx.lineTo(right - r, top);
      ctx.quadraticCurveTo(right, top, right, top + r);
      ctx.lineTo(right, bottom - r);
      ctx.quadraticCurveTo(right, bottom, right - r, bottom);
      ctx.lineTo(left, bottom);
      ctx.closePath();
    }

    ctx.fill();
    if (vm.borderWidth) {
      ctx.stroke();
    }
  };
  Chart.elements.Rectangle.prototype.__roundedTopPatched = true;
}

export default {
  props: {
    datagraph: {
      type: Object
    },
    cambio: Number
  },
  data() {
    return {
      idcanvas: "",
      chart: null,
      colorbase: [
        "#293462",
        "#f76262",
        "#216583",
        "#aee7e8",
        "#28c3d4",
        "#fbc99d",
        "#ed1250",
        "#10ddc2",
        "#042f4b",
        "#15b7b9",
        "#f57170",
        "#248ea9"
      ]
    };
  },
  created() {
    this.idcanvas = Math.random()
        .toString(36)
        .substr(2, 9);
  },
  mounted() {
    if (this.datagraph.data) {
      this.render(this);
    }
    // Redibuja la gráfica cuando cambia el tamaño de la ventana; sin esto el
    // canvas conserva su ancho anterior y se desborda del contenedor.
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    if (this._resizeTimer) {
      clearTimeout(this._resizeTimer);
    }
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    handleResize() {
      // Debounce: espera a que termine el resize antes de redibujar.
      if (this._resizeTimer) {
        clearTimeout(this._resizeTimer);
      }
      this._resizeTimer = setTimeout(() => {
        // offsetParent === null → el canvas está oculto (p.ej. en una pestaña
        // inactiva). Redibujarlo ahí lo colapsaría a ancho 0, así que se omite.
        if (this.chart && this.$el && this.$el.offsetParent !== null) {
          this.chart.resize();
          this.chart.update();
        }
      }, 150);
    },
    render(_this) {
      // const _this = this;
      Chart.defaults.global.defaultFontFamily = "'Montserrat', sans-serif"; // con esto configuramos el tipo de letra
      Chart.defaults.global.tooltips.backgroundColor = "rgba(45, 64, 89, 0.9)"; // con esto se configura el fondo del tooltip
      Chart.plugins.unregister(ChartDataLabels);

      const ctx = document.getElementById(_this.idcanvas);
      ctx.getContext("2d");


      if (_this.datagraph.type === 'horizontalBar' || _this.datagraph.type === 'pie'){
        _this.datagraph.plugins = [ChartDataLabels]
      }

      if (_this.chart) {
        // si la grafica ya existia la destruimos
        _this.chart.destroy();
      }

      _this.chart = new Chart(ctx, _this.datagraph);
    },
    updated(_this){
      _this.chart.data = _this.datagraph.data;
      _this.chart.update()
    }
  },
  watch: {
    cambio(newv, oldv) {
      if (this.datagraph.data) {
        this.updated(this);
      }
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/dashboard/GraphFrs.vue